import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'module-container',
  standalone: false,
  templateUrl: './module-container.component.html',
  styleUrls: ['./module-container.component.scss']
})
export class ModuleContainerComponent implements OnInit {
  @Input() title: string;
  @Input() customStyle: {};
  @Input() type: string;
  constructor() { }

  ngOnInit() {}

}
